// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3E6Am","infoBtn":"quickbooks_infoBtn__1Z0fE","formBox":"quickbooks_formBox__2Q6Jw","formFooter":"quickbooks_formFooter__27O41"};